import {Tooltip, styled} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const ToggleButton = styled('div')(({theme, style, selected}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: selected ? '' : 'pointer',
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1),
  backgroundColor: selected ? theme.palette.grey[900] : '',
  '&:hover': selected
    ? {}
    : {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
      },
  color: selected ? theme.palette.primary.main : theme.palette.grey[200],
  transition: 'color 250ms, background 250ms',
  ...style,
}));

/**
 * This toggle button wraps a material-ui toggle button and allows showing
 * a corresponding tooltip with help text. It will make sure that the selected
 * toggle button is still shown as selected.
 */
const ToggleButtonWithTooltip = props => {
  const {title, ...rest} = props;
  if (props.disabled) {
    return <ToggleButton aria-label={title} {...rest} />;
  } else {
    return (
      <Tooltip title={title}>
        <ToggleButton aria-label={title} {...rest} />
      </Tooltip>
    );
  }
};

ToggleButtonWithTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default ToggleButtonWithTooltip;
